import React from 'react';

import Image from 'next/image';

import { NEXT_PUBLIC_PRODUCT_IMAGE_BASE_URL } from '@/config/env';
import { nextImageWrapper } from '@/helpers/utils/cloudflare';
import { roundToTwoDecimalPlaces } from '@/helpers/utils/numberHelpers';
import { CartItem } from '@/types/Cart';

const Product = (data: CartItem) => {
  const productImage = nextImageWrapper(`${NEXT_PUBLIC_PRODUCT_IMAGE_BASE_URL}/${data.id}`);
  const productPrice = data.price && data.quantity ? data.price * data.quantity : '0';

  const handleLoadImage = () => {
    return productImage;
  };

  return (
    <div className="v2-flex v2-items-start v2-gap-1 v2-py-3 cart-product-card">
      <div className="v2-bg-[#F9FAFB] v2-flex v2-justify-center v2-items-center v2-h-[90px] v2-w-[90px]">
        <Image src={productImage} loader={handleLoadImage} alt="product-name" width={90} height={90} />
      </div>
      <div className="v2-flex v2-flex-col v2-gap-1 v2-flex-1">
        <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-[#101828] v2-text-base text-ellipsis">
          {data.name}
        </p>
        <div className="v2-flex v2-gap-2 v2-item-center v2-justify-between">
          <span className="v2-font-sweet-sans-pro v2-text-sm v2-text-[#101828]">Price:</span>
          <span className="v2-font-sweet-sans-pro v2-text-sm v2-text-[#101828]">
            ${roundToTwoDecimalPlaces(productPrice)}
          </span>
        </div>
        <div className="v2-flex v2-gap-2 v2-item-center v2-justify-between">
          <span className="v2-font-sweet-sans-pro v2-text-sm v2-text-[#101828]">Weight:</span>
          <span className="v2-font-sweet-sans-pro v2-text-sm v2-text-[#101828]">{data?.weight ?? '0'}</span>
        </div>
        <div className="v2-flex v2-gap-2 v2-item-center v2-justify-between">
          <span className="v2-font-sweet-sans-pro v2-text-sm v2-text-[#101828]">Quantity:</span>
          <span className="v2-font-sweet-sans-pro v2-text-sm v2-text-[#101828]">{data?.quantity ?? 1}</span>
        </div>
      </div>
    </div>
  );
};

export default Product;
